import "web-ui/tom-select"
import { Controller } from "@hotwired/stimulus"
import { morphdomIgnore } from "web-ui/morphdom/ignore"
import * as Log from "web-ui/log"

// Connects to data-controller="combo-box"
export default class extends Controller {
  static values = {
    placeholder: { type: String, default: "Search..." }
  }

  connect() {
    const select = this.element.querySelector("select")

    this.debug("Connect", { id: select.id, placeholder: this.placeholderValue })

    const hasBlankOption = select.querySelectorAll("option[value='']").length > 0

    const plugins = {
      "no_backspace_delete": {},
      "dropdown_input": { placeholder: this.placeholderValue },
      "dropdown_placement": {},
      "dropdown_scroll": {},
      "dropdown_open": {},
      "dropdown_close_on_scroll": {},
      "turbo_morph_sync": {},
      "submit_form": {},
      "blank_option": {}
    }

    if (!hasBlankOption) {
      delete plugins["blank_option"]
    }

    document.addEventListener("turbo:before-cache", this.beforeTurboCache)

    const body = document.querySelector("body")

    this.tomSelect = new TomSelect(select, {
      plugins: plugins,
      refreshThrottle: 0,
      dropdownParent: body,
      openOnFocus: false,
      allowEmptyOption: hasBlankOption,
      maxOptions: null,

      onFocus: () => {
        morphdomIgnore(this.element, true)
      },

      onBlur: () => {
        if (this.tomSelect.isFocused) {
          return
        }

        morphdomIgnore(this.element, false)
      },

      render: {
        dropdown: () => {
          return `<div id="${select.id}-dropdown"></div>`
        },
        item: (data, escape) => {
          return `<div title="${escape(data.text)}">${escape(data.text)}</div>`
        }
      }
    })
  }

  beforeTurboCache = () => {
    this.debug("Before Turbo Cache")

    this.tomSelect.destroy()
  }

  disconnect() {
    this.debug("Disconnect")

    document.removeEventListener("turbo:before-cache", this.beforeTurboCache)

    this.tomSelect.destroy()
  }

  debug(message, data={}) {
    if (this.tomSelect) {
      Object.assign(data, {
        id: this.tomSelect.input.id
      })
    }

    Log.debug("Combo Box - " + message, data)
  }
}
